import React from "react";
import filterStyles from "../../../filters/FilterPanel.module.css";
import layoutStyles from "../../../../styles/utilities/layout.module.css";

export interface ChartLegendProps {
  items?: string[];
  colorOf: (c: string) => string;
  title?: string | null;
  showCheckboxes?: boolean;
  checkedItems?: string[];
  onToggle?: (item: string) => void;
}

const ChartLegend: React.FC<ChartLegendProps> = ({
  items = [],
  colorOf,
  title = "Legend",
  showCheckboxes = false,
  checkedItems = [],
  onToggle,
}) => {
  if (!items || !items.length) return null;
  const isChecked = (it: string) => (checkedItems ? checkedItems.includes(it) : false);

  return (
    <div
      className={`${layoutStyles.flexColumn} ${layoutStyles.gap3}`}
      style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
    >
      {title && (
        <span
          style={{
            fontSize: "var(--font-size-sm)",
            fontWeight: "var(--font-weight-semibold)",
            color: "var(--color-text-secondary)",
            marginRight: "var(--spacing-lg)",
          }}
        >
          {title}:
        </span>
      )}
      {items.map((item) => (
        <label
          key={item}
          className={`${layoutStyles.flexRow} ${layoutStyles.itemsCenter} ${layoutStyles.gap2} ${layoutStyles.pointer} ${filterStyles.itemLabelHover}`}
        >
          {showCheckboxes ? (
            <>
              <input
                type="checkbox"
                checked={isChecked(item)}
                onChange={() => onToggle && onToggle(item)}
                className={filterStyles.checkboxColored}
                style={{
                  ["--checkbox-bg-color" as any]: colorOf(item),
                }}
                aria-label={`Toggle ${item}`}
              />
              <span className={filterStyles.labelText} style={{ marginLeft: "0.5rem" }}>
                {item}
              </span>
            </>
          ) : (
            <>
              <span
                className={layoutStyles.inlineBlock}
                style={{
                  backgroundColor: colorOf(item),
                  width: "1.25rem",
                  height: "1.25rem",
                  borderRadius: "var(--radius-sm)",
                }}
              />
              <span
                style={{
                  fontSize: "var(--font-size-sm)",
                  color: "var(--color-text-primary)",
                }}
              >
                {item}
              </span>
            </>
          )}
        </label>
      ))}
    </div>
  );
};

export default ChartLegend;
